module.exports = __webpack_public_path__ + "static/back_to_the_woods-562e174b11e5a07c71317f285aa6f820.jpg";